import { css } from '@emotion/core';
import { variables, mq } from '../../../cssInJs';

const numberOfTiles = [1, 2, 3, 3]
//const marginLR = [14, 14, 14, 14]
const marginTB = [14, 14, 14, 14]

const widthPercent = (index) => 100 / numberOfTiles[index] + '%'

const linkText = {
  color: '#fff',
  padding: '0 20px',
  '&:hover': {
    color: '#fff',
  }
}

export const tileListStyle = {
  tiles: mq({
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['1100px'],
    margin: 'auto'
  }),
  categoryList : mq({
    marginTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    marginBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth:['1100px'],
    margin: 'auto',
    'div.ff.form-group' : {
      maxWidth: '250px'
    }
  })
}

export const tileStyle = {
  tile: mq({
    paddingLeft : '10px',
    paddingRight : '10px',
    paddingTop: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    paddingBottom: [marginTB[0] / 2, marginTB[1] / 2, marginTB[2] / 2, marginTB[3] / 2],
    maxWidth: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexBasis: [widthPercent(0), widthPercent(1), widthPercent(2), widthPercent(3)],
    flexGrow: 0,
    flexShrink: 0
  }),
  tileLink: {
    background: variables.darkBlueColor,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
      textDecoration: 'none',
      background: variables.primaryColor
    }
  },
  prdImage: {
    backgroundColor: 'grey'
  },
  bg: {
    paddingTop: '210px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  shortDes : css({
    textAlign:'center',
    lineHeight : '1.3',
    marginTop : '1rem',
    marginBottom : '1rem',
    paddingInline: '1rem',
    color : '#fff',
    fontSize : '1rem'
  }),
  name: css(linkText, {
    fontWeight: 'bold',
    textAlign:'center',
    marginTop : '1rem',
    fontSize : '1.2rem',
    lineHeight : '1.3',
    color : '#fff'
  }),
  price: css(linkText, {
    marginTop: 'auto',
    textAlign:'center',
    marginBottom:'1rem',
    color : '#fff',
    fontSize : '1rem',
    fontWeight: 'bold',
    lineHeight: '1.3'
  }),
  accentBar: css({
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '4px',
    backgroundColor: variables.primaryColor,
    pointerEvents: 'none'
  })
}
